<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Customer Management</h1>
            <p class="page-subtitle">Manage your customers and their business information</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading customers...</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <div class="search-wrapper">
                <mat-icon class="search-icon">search</mat-icon>
                <input type="text" class="search-input" [(ngModel)]="searchText"
                    placeholder="Search by name or address..." />
                <mat-icon *ngIf="searchText" class="clear-icon" (click)="searchText = ''">close</mat-icon>
            </div>

            <button type="button" class="btn-primary" (click)="addNewCustomer()">
                <mat-icon>add_business</mat-icon>
                <span>Add Customer</span>
            </button>
        </div>

        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Name / Company</th>
                        <th>Address</th>
                        <th class="th-actions">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of filteredOrders" class="table-row">
                        <td>
                            <div class="customer-info">
                                <div class="customer-avatar">
                                    <mat-icon>business</mat-icon>
                                </div>
                                <span class="customer-name">{{ data.name }}</span>
                            </div>
                        </td>
                        <td>
                            <a [href]="data.locationLink" target="_blank" class="address-link">
                                <mat-icon class="location-icon">location_on</mat-icon>
                                <span>{{ data.address || '—' }}</span>
                            </a>
                        </td>
                        <td class="actions-cell">
                            <button class="btn-icon-action" (click)="editCustomer(data, $event)" title="More options">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <div *ngIf="selectedCustomerId === data.id" class="dropdown-menu"
                                [style.top]="dropdownPosition.top"
                                [style.right]="dropdownPosition.right">
                                <button class="dropdown-item" (click)="onEdit(data)">
                                    <mat-icon class="dropdown-icon edit-icon">edit</mat-icon>
                                    <span>Edit Customer</span>
                                </button>
                                <div class="dropdown-divider"></div>
                                <button class="dropdown-item dropdown-item-danger" (click)="onDelete(data)">
                                    <mat-icon class="dropdown-icon">delete</mat-icon>
                                    <span>Delete Customer</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Empty State -->
            <div *ngIf="filteredOrders.length === 0" class="empty-state">
                <mat-icon class="empty-icon">store</mat-icon>
                <h3>No customers found</h3>
                <p>Try adjusting your search or add a new customer</p>
            </div>
        </div>

        <div class="card-footer" *ngIf="filteredOrders.length > 0">
            <div class="pagination-info">
                Showing <strong>{{ filteredOrders.length }}</strong> of <strong>{{ customers.length }}</strong> customers
            </div>
            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1"
                    (click)="getCustomerList(currentPage - 1)" title="Previous page">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }" (click)="getCustomerList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages"
                    (click)="getCustomerList(currentPage + 1)" title="Next page">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
